const location = window.location;
const baseUrl = location.protocol + '//' + location.host;
const baseUrlByEnv = baseUrl.includes('localhost') ? 'http://localhost:8080' : baseUrl;

const BASE_URL = `${baseUrlByEnv}/api`;

export class RequestHistory {
  get() {
    const storage = window.localStorage;
    const result = storage.getItem('history') || '[]';
    return JSON.parse(result);
  }
  add(entry) {
    const history = this.get();
    const storage = window.localStorage;
    entry.timestamp = entry.timestamp || new Date().toISOString();
    history.splice(0, 0, entry);
    const maxEntries = 50;
    const historyStripped = history.slice(0, maxEntries);
    storage.setItem('history', JSON.stringify(historyStripped));
  }
}

export class ServiceClient {
  async getConfigs() {
    const url = this.url('/configs');
    return this.makeRequest(url);
  }
  async computeResult(ticker, features) {
    const url = this.url('/predict');
    const data = { ticker, features };
    return this.makeRequest(url, 'POST', data);
  }
  async makeRequest(url, method='GET', body=null) {
    const headers = this.getHeaders();
    const response = await fetch(url, { method, headers, body: body && JSON.stringify(body) });
    const data = await response.json();
    return data;
  }
  async getVolatilityHistory(ticker) {
    const url = this.url(`/volatility/${ticker}`);
    return this.makeRequest(url);
  }
  getHeaders() {
    return {
      'Content-Type': 'application/json'
    }
  }
  url(path) {
    return `${BASE_URL}${path}`;
  }
}

export const serviceClient = new ServiceClient();
export const requestHistory = new RequestHistory();
